module.exports = __webpack_public_path__ + "static/4-112764ed1503c90f87bbd1761c430e31.png";